export default "__VITE_ASSET__BxWMAI6u__"